<template>
    <div>
        <b-container fluid class="mt-2 px-1 px-sm-3 pb-2 team-page">
            <b-row>
                <b-col cols="" class="">
                    <b-row>
                        <b-col cols="">
                            <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
                                <h2 class="text-left mb-0">{{ $t('recruitingPage.tabLeads') }}</h2>
                                <div
                                    class="d-flex align-items-center justify-content-between justify-content-sm-center flex-wrap">
                                    <button class="btn btn-filter-section mx-1 my-1" @click="setViewMode()">
                                        <div class="d-flex align-items-center">
                                            <svg v-if="viewMode === 'table'" width="16" height="16" viewBox="0 0 16 16"
                                                fill="currentColor" class="bi bi-kanban" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M13.5 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h11zm-11-1a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-11z" />
                                                <path
                                                    d="M6.5 3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3zm-4 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3zm8 0a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V3z" />
                                            </svg>
                                            <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="currentColor"
                                                class="bi bi-list-ul" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd"
                                                    d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                                            </svg>
                                            <p class="mb-0 ml-2">{{ viewMode === 'table' ?
                                                $t('recruitingPage.boardView') : $t('recruitingPage.tableView') }}</p>
                                        </div>
                                    </button>
                                    <b-button v-if="tab === 'lead,applicant'" @click="addRecruitingRecord()"
                                        class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                                        variant="primary">
                                        <b-icon icon="plus" aria-hidden="true"></b-icon>
                                        <p class="mb-0 ml-2 text-white">{{ $t('recruitingPage.addLead') }}</p>
                                    </b-button>
                                    <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2 mt-0"
                                        v-if="viewMode === 'table' && tab === 'lead,applicant'">
                                        <template slot="button-content">
                                            <b-icon class="dots" icon="three-dots"></b-icon>
                                        </template>
                                        <b-dropdown-item-button class="mb-2" @click="downloadExcel">
                                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.exportCsv')
                                            }}</p>
                                        </b-dropdown-item-button>
                                        <b-dropdown-item-button @click="$bvModal.show('modal-bulk-upload')">
                                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('teamPage.importCsv')
                                            }}</p>
                                        </b-dropdown-item-button>
                                    </b-dropdown>

                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <div class="data-table team-data-table table-custom-border">
                                <div class="bg-white rounded" v-if="viewMode === 'table'">
                                    <div v-if="!isTableMounted || !tableViews.length"
                                        class="d-flex align-items-center px-3 py-3">
                                        <b-skeleton v-for="n in 4" :key="`view-tab-skeleton-${n}`" width="80px"
                                            height="26px" class="mr-3 mb-0"></b-skeleton>
                                    </div>
                                    <v-tabs v-else ref="viewsTabs" :key="`tabs-${tableViews.length}`"
                                        class="team-tabs mb-0" v-model="activeViewIndex" show-arrows>
                                        <v-tab v-for="(view, index) in tableViews"
                                            
                                            :key="`${viewKey(view)}-${index}`">
                                            {{ view.name }}
                                            <span v-if="viewCount(view) !== null" class="f-12 ml-1"> ({{ viewCount(view)
                                                }})</span>
                                        </v-tab>
                                        
                                    </v-tabs>
                                </div>
                                <div class="bg-white rounded" :class="viewMode !== 'kanban' ? 'pt-3 pt-sm-4' : ''">
                                    <div class="table_row team_table_row">
                                        <div class="equipment-border filter-box">
                                            <div class="d-flex px-3 px-sm-4"
                                                :class="viewMode !== 'kanban' ? 'mb-4' : 'mb-2'">
                                                <b-form-group class="text-left label font-weight-normal search-field mb-0">
                                                    <b-input-group class="username-input-field" v-if="viewMode === 'table'">
                                                        <b-form-input type="text" :placeholder="$t('recruitingPage.search')"
                                                            v-model="filterFields.search" class="unit f-12"
                                                            @keyup.enter="getAllRecruitingData()"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button variant="primary" @click="getAllRecruitingData()">
                                                                <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                                                        stroke="white" stroke-width="2"
                                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M10 10.5L13 13.5" stroke="white"
                                                                        stroke-width="2" stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                                </svg>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                                <div class="ml-auto align-items-center d-none d-sm-flex flex-wrap"
                                                    v-if="viewMode != 'kanban'">
                                                    <button class="btn btn-filter-section" v-if="!isDefaultActiveView"
                                                        @click="deleteView()">
                                                        <div class="d-flex align-items-center">
                                                            <svg width="19" height="20" viewBox="0 0 19 20" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M1 5.15704H17.6139" stroke="#000000"
                                                                    stroke-width="1.5" stroke-linecap="round"
                                                                    stroke-linejoin="round" />
                                                                <path
                                                                    d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                                    stroke="#000000" stroke-width="1.5"
                                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                                <path
                                                                    d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                                    stroke="#000000" stroke-width="1.5"
                                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M7.23175 9.3065V14.8466" stroke="#000000"
                                                                    stroke-width="1.5" stroke-linecap="round"
                                                                    stroke-linejoin="round" />
                                                                <path d="M11.385 9.3065V14.8466" stroke="#000000"
                                                                    stroke-width="1.5" stroke-linecap="round"
                                                                    stroke-linejoin="round" />
                                                            </svg>
                                                            <p class="mb-0 ml-2">{{ $t('teamPage.delete') }}</p>
                                                        </div>
                                                    </button>
                                                    <div class="position-relative"
                                                        :class="!isDefaultActiveView ? 'ml-2' : ''">
                                                        <div class="position-absolute notification-badge"
                                                            v-if="activeFiltersCount">
                                                            {{ activeFiltersCount }}
                                                        </div>
                                                        <button class="btn btn-filter-section"
                                                            @click="$bvModal.show('modal-filter')">
                                                            <div class="d-flex align-items-center">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="lucide lucide-sliders-horizontal w-4 h-4"
                                                                    data-id="element-964">
                                                                    <line x1="21" x2="14" y1="4" y2="4"></line>
                                                                    <line x1="10" x2="3" y1="4" y2="4"></line>
                                                                    <line x1="21" x2="12" y1="12" y2="12"></line>
                                                                    <line x1="8" x2="3" y1="12" y2="12"></line>
                                                                    <line x1="21" x2="16" y1="20" y2="20"></line>
                                                                    <line x1="12" x2="3" y1="20" y2="20"></line>
                                                                    <line x1="14" x2="14" y1="2" y2="6"></line>
                                                                    <line x1="8" x2="8" y1="10" y2="14"></line>
                                                                    <line x1="16" x2="16" y1="18" y2="22"></line>
                                                                </svg>
                                                                <p class="mb-0 ml-2">{{ $t('recruitingPage.filters') }}</p>
                                                            </div>
                                                        </button>
                                                    </div>
                                                    <div class="table-columns-section ml-2 mt-0"
                                                        @click="showColumns = true">
                                                        <button class="btn btn-table-columns-section">
                                                            <div class="d-flex align-items-center">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                                                    height="24" viewBox="0 0 24 24" fill="none"
                                                                    stroke="currentColor" stroke-width="2"
                                                                    stroke-linecap="round" stroke-linejoin="round"
                                                                    class="lucide lucide-columns2 w-4 h-4"
                                                                    data-id="element-961">
                                                                    <rect width="18" height="18" x="3" y="3"
                                                                        rx="2"></rect>
                                                                    <path d="M12 3v18"></path>
                                                                </svg>
                                                                <p class="mb-0 ml-2">{{ $t('recruitingPage.columns') }}
                                                                </p>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <LeadsKanban v-if="viewMode === 'kanban'" :tab="kanbanTab"
                                            :search="filterFields.search" :owner="filterFields.owner"
                                            :job="filterFields.job" :refreshKey="kanbanRefreshKey"
                                            @openNote="openRecruitingNoteById" @openLead="openRecruitingDetailsById"
                                            @updated="getAllRecruitingData" />
                                        <div v-else-if="!isTableMounted && viewMode === 'table'" class="mt-2"
                                            style="height: calc(100vh - 225px); overflow: hidden;">
                                            <b-skeleton-table :rows="17" :columns="7"
                                                :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                                        </div>
                                        <b-table v-else-if="isTableMounted && viewMode === 'table'" ref="tableRef"
                                            class="mt-2" responsive :fields="fields.length ? fields : translatedFields"
                                            :items="items" hover
                                            :sticky-header="'calc(100vh - 330px)'" :current-page="currentPage"
                                            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true"
                                            :busy.sync="isBusy" :show-empty="emptyTable">
                                            <template #cell(name)="data">
                                                <div>
                                                    <p class="text_primary cursor-pointer mb-0"
                                                        @click="openRecruitingDetails(data.item)">{{ data.value }}
                                                    </p>
                                                </div>
                                            </template>
                                            <template #cell(status)="data">
                                                <b-button
                                                    class="btn f-14 pe-none d-flex justify-content-center align-items-center"
                                                    :variant="data.item.status === 'New Lead' || data.item.status === 'Applied' ? 'warning-status' : data.item.status === 'Rejected' ? 'danger-status' : data.item.status === 'Contacted' || data.item.status === 'Under Review' || data.item.status === 'Hired' ? 'primary-status' : data.item.status === 'Onboarding' || data.item.status === 'Screening' ? 'success-status' : 'secondary-status'">
                                                    <p class="mb-0">{{ data.item.status }}</p>
                                                </b-button>
                                            </template>
                                            <template #cell(last_note)="data">
                                                <v-app v-if="data.value" class="d-contents align-items-center">
                                                    <v-tooltip bottom>
                                                        <template #activator="{ on, attrs }">
                                                            <span
                                                                class="w-fit-content item-description text_primary text-left maxw-200px cursor-pointer"
                                                                @click.stop="editNote(data.item)" v-on="on"
                                                                v-bind="attrs">{{
                                                                    htmlToPlainText(data.value) }}</span>
                                                        </template>
                                                        <div class="note-tooltip-content">{{ htmlToPlainText(data.value) }}
                                                        </div>
                                                    </v-tooltip>
                                                </v-app>
                                                <span v-else class="d-flex text_primary cursor-pointer"
                                                    @click.stop="editNote(data.item)">-
                                                </span>
                                            </template>
                                        </b-table>
                                        <div v-if="viewMode === 'table'" class="entries-pagination px-0 px-sm-2">
                                            <div class="d-flex align-items-center flex-wrap">
                                                <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                                                    <b-form-select v-model="perPage" :options="pageOptions" />
                                                </div>
                                                <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">
                                                    {{ positionText }}
                                                </p>
                                                <div class="pagination">
                                                    <b-pagination v-model="currentPage" :total-rows="rows"
                                                        :per-page="perPage" aria-controls="my-table"></b-pagination>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
        <b-modal id="modal-filter" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
            :body-class="'px-3 pt-3 pb-1'" no-close-on-esc>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('recruitingPage.filtersModalTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="body" v-if="viewMode === 'table'">
                <b-form-group :label="$t('recruitingPage.statusLabel')" class="text-left select_arrow label mb-0">
                    <b-form-select class="input f-12 mb-3" :options="statusFilterOptions" v-model="filterFields.status"
                        @change="getAllRecruitingData()"></b-form-select>
                </b-form-group>
            </div>
            <div class="body" v-else>
                <b-form-group :label="$t('recruitingPage.recruiterLabel')" class="text-left w-equipment-box mb-3">
                    <v-select class="f-12 bg-grey" :options="nameOptions" :reduce="(option) => option.id"
                        v-model="filterFields.owner" @input="getAllRecruitingData()" @search="searchUsers" />
                </b-form-group>
                <b-form-group :label="$t('recruitingPage.jobLabel')" class="text-left w-equipment-box mb-3">
                    <v-select class="f-12 bg-grey" :options="jobOptions" :reduce="(option) => option.id"
                        v-model="filterFields.job" @input="getAllRecruitingData()" @search="searchJobs" />
                </b-form-group>
            </div>
            <template #modal-footer="">
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
                        @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('recruitingPage.reset')
                        }}</b-button>
                    <b-button class="mx-0 h-40px w-100px m-0 m-0" block
                        :variant="(viewMode !== 'table' || isDefaultActiveView) ? 'secondary' : 'primary'"
                        @click="onFilterModalSave()">{{ (viewMode !== 'table' || isDefaultActiveView) ?
                            $t('recruitingPage.close') : $t('teamPage.save') }}</b-button>
                </div>
            </template>
        </b-modal>
        <!-- Import CSV Modal  -->
        <b-modal id="modal-bulk-upload" centered hide-footer :title="$t('teamPage.importCsvTitle')" @shown="resetField"
            no-close-on-backdrop>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('teamPage.importCsvTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    {{ $t('teamPage.closeModal') }}
                </b-button>
            </template>
            <div class="d-block text-center">
                <b-row class="import-excel-modal mx-0">
                    <b-col cols="12" class="px-0">
                        <div class="upload-btn-wrapper mt-0">
                            <b-img :src="require('@/assets/drop.svg')"></b-img>
                            <button class="foo" v-if="!fileName">
                                {{ $t('teamPage.dropDocument') }}
                            </button>
                            <button v-else class="foo">{{ fileName }}</button>
                            <input ref="docFile" type="file" name="docFile" @change="handleFileUpload" accept=".csv" />
                            <p v-if="bulkErrors && bulkErrors.document" class="field-error">
                                {{ bulkErrors.document }}
                            </p>
                        </div>
                    </b-col>
                    <b-col cols="12" class="text-left cursor-pointer mt-2 pt-1 pl-1">
                        <a class="download-sample-file" href="/files/sample-leads.csv" download="sample-leads.csv">
                            <b-img :src="require('@/assets/sample-file.svg')"></b-img>
                            {{ $t('teamPage.downloadSampleFile') }}
                        </a>
                    </b-col>
                </b-row>
            </div>
            <div class="text-right modal-footer border-0 p-0">
                <b-button class="mx-0 mr-3 h-40px w-100px" @click="$bvModal.hide('modal-bulk-upload')"
                    variant="secondary">{{ $t('teamPage.cancel') }}</b-button>
                <b-button class="mx-0 mb-0 h-40px w-100px" variant="primary" @click="bulkUploadLeads">{{
                    $t('teamPage.save') }}</b-button>
            </div>
        </b-modal>
        <b-modal id="modal-bulk-upload-errors" centered hide-footer size="md" no-close-on-backdrop>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('teamPage.csvImportErrors') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    {{ $t('teamPage.closeModal') }}
                </b-button>
            </template>
            <div class="bulk-upload-errors-container">
                <p v-if="bulkUploadSummary" class="mb-3 font-weight-bold">{{ bulkUploadSummary }}</p>
                <div class="errors-list" style="max-height: 400px; overflow-y: auto;">
                    <div v-for="(error, index) in bulkUploadErrors" :key="index" class="error-item mb-2 p-2"
                        style="background: #fff3f3; border-left: 3px solid #dc3545; border-radius: 4px;">
                        <p class="mb-0"><strong>{{ error.row }}:</strong> {{ error.message }}</p>
                    </div>
                </div>
            </div>
            <div class="text-right modal-footer border-0 p-0 mt-3">
                <b-button class="mx-0 h-40px w-100px" @click="$bvModal.hide('modal-bulk-upload-errors')"
                    variant="primary">{{ $t('teamPage.close') }}</b-button>
            </div>
        </b-modal>
        <AddLeadRecord :allowAddLead="allowAddLead" @close="allowAddLead = false" @refreshLeads="refreshCurrentView" />
        <RecruitingDetails :leadID="leadID" :initialTab="pendingTab" @close="leadID = null"
            @updateData="refreshCurrentView" />
            <TableColumns :defaultView="isDefaultActiveView" :showColumns="showColumns" :fields="availableColumns"
      :viewColumns="tableViews.length > 0 ? tableViews[activeViewIndex] : []"
      @getUpdatedFieldsList="getUpdatedFieldsList($event)" @updateFields="updateFields($event)"
      @resetTableFields="resetTableFields()" @resetData="showColumns = false" />
    <AddTableViewModal :table="'recruitment'" :seedColumns="currentColumnsState" :seedFilters="currentFiltersQuery"
      @created="onViewCreated" @cancel="activeViewIndex = lastDefaultViewIndex >= 0 ? lastDefaultViewIndex : 0" />
    <DeleteModal v-if="showDeleteViewModal" @confirm="confirmDeleteView($event)"
      :message="$t('teamPage.confirmDeleteView')" />
    </div>
</template>
<script>
import * as moment from "moment-timezone";
import { mapActions, mapGetters } from "vuex";
import 'vue2-datepicker/index.css';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import TableColumns from "@/components/Shared/TableColumns.vue";
import AddTableViewModal from "@/components/Shared/TableViews/AddTableViewModal.vue";
import DeleteModal from "@/components/DeleteModal.vue";
import AddLeadRecord from '@/components/Recruiting/AddLeadRecord.vue';
import RecruitingDetails from '@/views/website/Recruiting/RecruitingDetails.vue';
import LeadsKanban from '@/components/Recruiting/LeadsKanban.vue';
export default {
    name: "Recruiting",
    components: { AddLeadRecord, RecruitingDetails, LeadsKanban, vSelect, TableColumns, AddTableViewModal, DeleteModal },
    data() {
        return {
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
                    if (!value) return null
                    const formats = [
                        'll', 'LL',
                        'MMM D, YYYY', 'MMMM D, YYYY',
                        'M/D/YYYY', 'MM/DD/YYYY',
                        'M-D-YYYY', 'MM-DD-YYYY',
                        'YYYY-MM-DD', 'YYYY/MM/DD',
                        'D MMM YYYY', 'D MMMM YYYY',
                        'D/M/YYYY', 'DD/MM/YYYY',
                    ]
                    const m = moment(value, formats, true)
                    if (m.isValid()) return m.toDate()
                    const lenient = moment(value)
                    return lenient.isValid() ? lenient.toDate() : null
                }
            },
            searchName: null,
            allowAddLead: false,
            leadID: null,
            pendingTab: 0,
            allowAddRecruitingRecord: false,
            searchType: null,
            currentPage: 1,
            sortBy: undefined,
            isTableMounted: false,
            bulkUploadErrors: [],
            bulkUploadSummary: '',
            defaultData: {},
            sortDesc: undefined,
            emptyTable: false,
            jobOptions: [],
            isBusy: false,
            rows: 1,
            positionText: "",
            items: [],
            tab: 'lead,applicant',
            viewMode: 'kanban',
            kanbanRefreshKey: 0,
            showDivision: false,
            showPublic: false,
            modelType: null,
            isTagDoc: false,
            archivedDocsCount: 0,
            sendCount: 0,
            tableViews: [],
            activeViewIndex: 0,
            activeViewFiltersRaw: '',
            fields: [],
            showColumns: false,
            showDeleteViewModal: false,
            receivedCount: 0,
            perPage: 25,
            selectedRows: [],
            fileName: null,
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            filterFields: {
                search: '',
                status: '',
                owner: '',
                job: ''
            },
            leadCount: 0,
            availableColumns: [],
            applicantCount: 0,
            hiredCount: 0,
            terminatedCount: 0,
            document: null,
            errors: {
                date: null,
                name: null,
                document: null,
            },
            bulkErrors: {
                errors: null
            },
            nameOptions: [],
        };
    },
    computed: {
        ...mapGetters(["company", "allTeamMembers"]),
        kanbanTab() {
            // One combined board across every tab (leads, applicants, hired, terminated).
            return 'lead,applicant,hired,terminated';
        },
        translatedFields() {
            return [
                { label: this.$t('recruitingPage.columnName'), key: "name", sortable: true, thClass: 'font-table-weight-bold', stickyColumn: true },
                { key: "phone", label: this.$t('recruitingPage.columnPhone'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "email", label: this.$t('recruitingPage.columnAppEmail'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "dob", label: this.$t('recruitingPage.columnDob'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "date", label: this.$t('recruitingPage.columnAppDate'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "last_activity", label: this.$t('recruitingPage.columnLastActivity'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "applied_at", label: this.$t('recruitingPage.columnAppliedAt'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "hired_at", label: this.$t('recruitingPage.columnHiredAt'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "terminated_at", label: this.$t('recruitingPage.columnTerminatedAt'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "job", label: this.$t('recruitingPage.columnJob'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "last_note", label: this.$t('recruitingPage.columnLastNote'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "owner", label: this.$t('recruitingPage.columnOwner'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "status", label: this.$t('recruitingPage.columnStatus'), sortable: true, thClass: 'font-table-weight-bold' },
            ]

        },
        statusFilterOptions() {
            const opts = [{ value: '', text: '' }];
            if (this.tab === 'lead,applicant') {
                opts.push(
                    { value: 'New Lead', text: this.$t('recruitingPage.statusNewLead') },
                    { value: 'Contacted', text: this.$t('recruitingPage.statusContacted') },
                    { value: 'Follow Up', text: this.$t('recruitingPage.statusFollowUp') },
                    { value: 'Onboarding', text: this.$t('recruitingPage.statusOnboarding') },
                    { value: 'Lead Closed', text: this.$t('recruitingPage.statusLeadClosed') },
                    { value: 'Applied', text: this.$t('recruitingPage.statusApplied') },
                    { value: 'Under Review', text: this.$t('recruitingPage.statusUnderReview') },
                    { value: 'Screening', text: this.$t('recruitingPage.statusScreening') },
                    { value: 'Rejected', text: this.$t('recruitingPage.statusRejected') },
                );
            }
            return opts;
        },
        activeFiltersCount() {
            const keys = this.viewMode === 'kanban' ? ['owner', 'job'] : ['search', 'status'];
            return keys.reduce((count, key) => {
                const val = this.filterFields[key];
                return val !== '' && val !== null && val !== undefined ? count + 1 : count;
            }, 0);
        },
        columnLabelMap() {
            // Key -> translated label, so backend view columns keep their i18n labels.
            return this.translatedFields.reduce((map, f) => {
                map[f.key] = f.label;
                return map;
            }, {});
        },
        isDefaultActiveView() {
            const v = this.tableViews[this.activeViewIndex];
            return !v || v.id == null || v.is_default === true;
        },
        contentLoading() {
            return !this.isTableMounted || !this.tableViews.length;
        },
        lastDefaultViewIndex() {
            let last = -1;
            this.tableViews.forEach((v, idx) => {
                if (v && (v.id == null || v.is_default === true)) last = idx;
            });
            return last;
        },
        currentColumnsState() {
            const view = this.tableViews[this.activeViewIndex];
            const source = view && Array.isArray(view.columns) ? view.columns : this.availableColumns;
            return (source || []).map(c => ({ key: c.key, visible: !!c.visible }));
        },
        currentFiltersQuery() {
            const parts = [`tab=${encodeURIComponent(this.tab)}`];
            ['search', 'status'].forEach(key => {
                const val = this.filterFields[key];
                if (val === '' || val === null || val === undefined) return;
                parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
            });
            return parts.join('&');
        },
    },
    methods: {
        ...mapActions([
            "setLoader",
            "setNotification",
            "getRecruitingData",
            "getExportRecruitingData",
            "getAllTeamMembers",
            "addBulkLead",
            "getTableViews",
            "updateTableView",
            "deleteTableView"
        ]),
        async bulkUploadLeads() {
            if (this.document) {
                this.setLoader(true)
                this.errors = {
                    document: null,
                };
                try {
                    let formData = new FormData();
                    formData.append("file", this.document);
                    const newMembers = await this.addBulkLead(formData);
                    if (newMembers) {
                        await this.getAllRecruitingData();
                        await this.setNotification({
                            msg: this.$t('recruitingPage.importSuccess'),
                            type: "success",
                            color: "green",
                        });
                        this.$bvModal.hide("modal-bulk-upload");
                        this.setLoader(false)
                    }
                } catch (e) {
                    this.setLoader(false)
                    if (typeof e === 'object' && e !== null) {
                        // Parse row errors from the response
                        this.bulkUploadErrors = [];
                        this.bulkUploadSummary = e.summary || '';
                        Object.keys(e).forEach((key) => {
                            if (key.startsWith('row no:')) {
                                this.bulkUploadErrors.push({
                                    row: key,
                                    message: e[key]
                                });
                            }
                        });
                        if (this.bulkUploadErrors.length > 0) {
                            this.$bvModal.hide('modal-bulk-upload');
                            this.$bvModal.show('modal-bulk-upload-errors');
                        } else {
                            await this.setNotification({
                                msg: this.$t('recruitingPage.csvErrors'),
                                type: "error",
                                color: "red",
                            });
                        }
                    } else {
                        await this.setNotification({
                            msg: "The Uploaded CSV has Wrong/Missing Fields.",
                            type: "error",
                            color: "red",
                        });
                    }
                }
            } else {
                this.bulkErrors = {
                    document: this.$t('recruitingPage.fieldRequired'),
                };
            }
        },
        handleFileUpload() {
            this.document = this.$refs.docFile.files[0];
            this.fileName = this.document.name;
        },
        resetField() {
            this.$refs.docFile.value = null;
            this.fileName = null;
            this.document = null;
            this.bulkErrors = {
                document: null,
            };
        },
        setViewMode() {
            this.viewMode = this.viewMode === 'kanban' ? 'table' : 'kanban'
            // Keep the Kanban filters (owner/job); only clear the table-only filters.
            this.filterFields.search = ''
            this.filterFields.status = ''
            this.getAllRecruitingData()
        },
        async searchUsers(searchText) {
            let options = []
            let url = `page=1&page_size=20&name=${searchText}`;
            await this.getAllTeamMembers(url);
            this.allTeamMembers.map((member) => {
                options.push({
                    id: `${member.id}`,
                    label: member.user.first_name + ' ' + member.user.last_name,
                });
            });
            this.nameOptions = options
            this.nameOptions = [...new Map(this.nameOptions.map(item => [item['id'], item])).values()]
        },
        async searchJobs(searchText) {
            let options = []
            let url = `page=1&page_size=20&name=${searchText}`;
            const data = await this.getRecruitingData({ type: "job", url });
            data.data.map((job) => {
                options.push({
                    id: `${job.id}`,
                    label: job.name,
                });
            });
            this.jobOptions = options
            this.jobOptions = [...new Map(this.jobOptions.map(item => [item['id'], item])).values()]
        },
        // Persist the Kanban filters (owner/job) so they survive reloads.
        saveKanbanFilters() {
            const ownerOpt = this.nameOptions.find((o) => o.id === this.filterFields.owner);
            const jobOpt = this.jobOptions.find((o) => o.id === this.filterFields.job);
            const payload = {
                owner: this.filterFields.owner ? { id: this.filterFields.owner, label: ownerOpt ? ownerOpt.label : '' } : null,
                job: this.filterFields.job ? { id: this.filterFields.job, label: jobOpt ? jobOpt.label : '' } : null,
            };
            localStorage.setItem('recruitingKanbanFilters', JSON.stringify(payload));
        },
        loadKanbanFilters() {
            try {
                const saved = JSON.parse(localStorage.getItem('recruitingKanbanFilters') || '{}');
                if (saved.owner && saved.owner.id) {
                    this.filterFields.owner = saved.owner.id;
                    // Seed the dropdown option so it shows the saved label (no extra fetch).
                    if (!this.nameOptions.some((o) => o.id === saved.owner.id)) {
                        this.nameOptions.push({ id: saved.owner.id, label: saved.owner.label });
                    }
                }
                if (saved.job && saved.job.id) {
                    this.filterFields.job = saved.job.id;
                    if (!this.jobOptions.some((o) => o.id === saved.job.id)) {
                        this.jobOptions.push({ id: saved.job.id, label: saved.job.label });
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },
        htmlToPlainText(htmlString) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlString;
            return tempDiv.textContent || tempDiv.innerText || '';
        },
        formatTooltipText(text) {
            const maxLineLength = window.screen.width <= 767 ? 50 : 80;
            let formattedText = "";
            let lineLength = 0;

            text.split(' ').forEach(word => {
                if (lineLength + word.length + 1 > maxLineLength) {
                    formattedText += "\n";
                    lineLength = 0;
                }
                formattedText += (lineLength === 0 ? "" : " ") + word;
                lineLength += word.length + 1;
            });

            return formattedText;
        },
        openRecruitingDetails(item) {
            this.pendingTab = 0;
            this.leadID = item.id;

        },
        openRecruitingDetailsById(id) {
            this.pendingTab = 0;
            this.leadID = id;
        },
        openRecruitingNoteById(id) {
            this.pendingTab = 2;
            this.leadID = id;
        },
        open(id) {
            this.pendingTab = 0;
            this.leadID = id;
        },
        refreshCurrentView() {
            // Always refresh counts/table; reload the board when it's the active view.
            this.getAllRecruitingData();
            if (this.viewMode === 'kanban') this.kanbanRefreshKey++;
        },
        editNote(item) {
            this.pendingTab = 2;
            this.leadID = item.id;
        },

        addRecruitingRecord() {
            this.allowAddLead = true;
        },
        setTab(tab) {
            this.tab = tab;
            this.resetFilterFields();
        },
        async resetFilterFields() {
            this.filterFields = {
                search: '',
                status: '',
                owner: '',
                job: ''
            }
            await this.getAllRecruitingData();
        },
        async downloadExcel() {
            try {
                this.setLoader(true)
                const { excel_file } = await this.getExportRecruitingData()
                window.open(process.env.VUE_APP_API_URL + excel_file, "_blank");
                await this.setNotification({
                    msg: this.$t('teamPage.fileExported'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false)
            }
            catch (e) {
                this.setLoader(false)
                console.log(e)
            }
        },
        async getAllRecruitingData() {
            try {
                this.items = []
                this.isBusy = true
                let url = ""
                Object.keys(this.filterFields).map((key) => {
                    // owner/job are Kanban-only filters — handled by the board, not the table.
                    if (key === 'owner' || key === 'job') return;
                    if (this.filterFields[key] !== '') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }

                url += `page=${this.currentPage}&page_size=${this.perPage}&tab=${this.tab}`
                const data = await this.getRecruitingData({ type: this.tab, url, company_id: this.userCompany });
                this.items = []
                this.leadCount = data.counts.lead >= 0 ? data.counts.lead + (data.counts.applicant >= 0 ? data.counts.applicant : 0) : 0
                this.hiredCount = data.counts.hired >= 0 ? data.counts.hired : 0
                this.terminatedCount = data.counts.terminated >= 0 ? data.counts.terminated : 0
                if (data.total_entries_count) {
                    data.data.forEach((item) => {
                        this.items.push({
                            id: item.id,
                            email: item.email ? item.email : '-',
                            phone: item.phone ? item.phone : '-',
                            name: item.name,
                            date: item.date ? moment(item.date).format('ll') : '-',
                            last_activity: item.last_activity ? moment(item.last_activity).format('ll') : '-',
                            owner: item.owner ? item.owner.name : '-',
                            status: item.status,
                            job: item.job ? item.job.name : '-',
                            last_note: item.last_note ? item.last_note.note : '-',
                            applied_at: item.applied_at ? moment(item.applied_at).format('ll') : '-',
                            hired_at: item.hired_at ? moment(item.hired_at).format('ll') : '-',
                            rejected_at: item.rejected_at ? moment(item.rejected_at).format('ll') : '-',
                            terminated_at: item.terminated_at ? moment(item.terminated_at).format('ll') : '-',
                            dob: item.dob ? moment(item.dob).format('ll') : '-',
                        })
                    })

                    this.rows = data.total_entries_count
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('recruitingPage.positionText', { start, end, total: data.total_entries_count })
                }
                else {
                    this.rows = 0
                    this.positionText = this.$t('recruitingPage.emptyPosition')
                }
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isTableMounted = true
                this.isBusy = false
                console.log(e)
            }
        },
        async loadTableViews() {
            try {
                const data = await this.getTableViews('recruitment');
                this.availableColumns = data.available_columns || [];
                this.tableViews = data.views || [];
                const defaultIndex = this.tableViews.findIndex(v => v.id == null || v.is_default === true);
                const targetIndex = defaultIndex >= 0 ? defaultIndex : 0;
                if (this.activeViewIndex !== targetIndex) {
                    this.activeViewIndex = targetIndex;
                } else {
                    this.applyActiveView();
                }
                this.refreshTabSlider();
            }
            catch (e) {
                console.log(e)
            }
        },
        viewKey(view) {
            if (!view) return '';
            return view.id != null ? `view-${view.id}` : `default-${view.slug || view.name || 'default'}`;
        },
        viewCount(view) {
            // Only the default status-group views map to a count badge.
            const f = view && view.filters ? view.filters : '';
            if (!f) return null;
            if (f.includes('tab=terminated')) return this.terminatedCount || 0;
            if (f.includes('tab=hired')) return this.hiredCount || 0;
            if (f.includes('lead')) return this.leadCount || 0;
            return null;
        },
        applyActiveView() {
            const view = this.tableViews[this.activeViewIndex];
            if (!view) return;
            this.refreshTabSlider();
            const ordered = (view.columns || [])
                .filter(c => c && c.visible)
                .slice()
                .sort((a, b) => {
                    const ao = a.display_order == null ? -Infinity : a.display_order;
                    const bo = b.display_order == null ? -Infinity : b.display_order;
                    return ao - bo;
                });
            this.fields = ordered.map(col => ({
                key: col.key,
                label: this.columnLabelMap[col.key] || col.label,
                sortable: !!col.sortable,
                stickyColumn: !!col.stickyColumn,
                thClass: 'font-table-weight-bold',
            }));
            this.activeViewFiltersRaw = view.filters || '';
            this.applyFiltersFromView(view.filters || '');
            this.currentPage = 1;
            this.getAllRecruitingData();
        },
        applyFiltersFromView(filtersQuery) {
            // Reset the table-scoped filters + tab, keeping the Kanban-only owner/job.
            this.tab = 'lead,applicant';
            this.filterFields.search = '';
            this.filterFields.status = '';
            if (!filtersQuery) return;
            const params = new URLSearchParams(filtersQuery);
            params.forEach((value, key) => {
                if (key === 'tab') { this.tab = value; return; }
                if (key === 'search' || key === 'status') this.filterFields[key] = value;
            });
        },
        openAddView() {
            this.$bvModal.show('modal-add-table-view');
        },
        async onViewCreated(view) {
            await this.loadTableViews();
            let foundIdx = -1;
            if (view && view.id != null) {
                foundIdx = this.tableViews.findIndex(v => v.id === view.id);
            }
            if (foundIdx < 0) foundIdx = this.tableViews.length - 1;
            const targetIndex = foundIdx >= 0 ? foundIdx : 0;
            if (this.activeViewIndex !== targetIndex) {
                this.activeViewIndex = targetIndex;
            } else {
                this.applyActiveView();
            }
        },
        deleteView() {
            const view = this.tableViews[this.activeViewIndex];
            if (!view || view.id == null || view.is_default === true) return;
            this.showDeleteViewModal = true;
        },
        async confirmDeleteView(status) {
            if (!status) {
                this.showDeleteViewModal = false;
                return;
            }
            const view = this.tableViews[this.activeViewIndex];
            if (!view || view.id == null) {
                this.showDeleteViewModal = false;
                return;
            }
            try {
                this.setLoader(true);
                await this.deleteTableView({ table: 'recruitment', id: view.id });
                await this.setNotification({
                    msg: this.$t('teamPage.viewDeleted', { name: view.name }),
                    type: 'success',
                    color: 'green',
                });
                this.showDeleteViewModal = false;
                await this.loadTableViews();
                const defaultIndex = this.tableViews.findIndex(v => v.id == null || v.is_default === true);
                const targetIndex = defaultIndex >= 0 ? defaultIndex : 0;
                if (this.activeViewIndex !== targetIndex) {
                    this.activeViewIndex = targetIndex;
                } else {
                    this.applyActiveView();
                }
                this.setLoader(false);
            } catch (e) {
                this.setLoader(false);
                this.showDeleteViewModal = false;
                await this.setNotification({
                    msg: typeof e === 'string' ? e : (e && e.detail) || this.$t('teamPage.failedDeleteView'),
                    type: 'error',
                    color: 'red',
                });
            }
        },
        async getUpdatedFieldsList(updatedFields) {
            this.fields = this.mapCatalogToFields(updatedFields);
            await this.persistColumnsForActiveView(updatedFields);
        },
        async updateFields(updatedFields) {
            this.fields = this.mapCatalogToFields(updatedFields);
            await this.persistColumnsForActiveView(updatedFields);
        },
        mapCatalogToFields(catalogFields) {
            return (catalogFields || [])
                .filter(f => !!f.visible)
                .map(col => ({
                    key: col.key,
                    label: this.columnLabelMap[col.key] || col.label,
                    sortable: !!col.sortable,
                    stickyColumn: !!col.stickyColumn,
                    thClass: 'font-table-weight-bold',
                }));
        },
        async persistColumnsForActiveView(updatedFields) {
            const view = this.tableViews[this.activeViewIndex];
            if (!view) return;
            const visibleCols = (updatedFields || []).filter(f => !!f.visible);
            const catalogByKey = new Map((this.availableColumns || []).map(c => [c.key, c]));
            const newColumns = visibleCols.map((f, idx) => {
                const meta = catalogByKey.get(f.key) || {};
                return { ...meta, key: f.key, visible: true, display_order: idx };
            });
            this.$set(this.tableViews, this.activeViewIndex, { ...view, columns: newColumns });
            if (this.isDefaultActiveView) return; // default view: frontend-only
            const payload = {
                columns: visibleCols.map((f, idx) => ({ key: f.key, visible: true, display_order: idx + 1 })),
            };
            try {
                const updated = await this.updateTableView({ table: 'recruitment', id: view.id, payload });
                this.$set(this.tableViews, this.activeViewIndex, updated);
            } catch (e) {
                await this.setNotification({
                    msg: typeof e === 'string' ? e : (e && e.detail) || this.$t('teamPage.failedSaveCols'),
                    type: 'error',
                    color: 'red',
                });
            }
        },
        async resetTableFields() {
            this.showColumns = false;
            if (this.isDefaultActiveView) {
                await this.loadTableViews();
                return;
            }
            const defaultView = this.tableViews.find(v => v && (v.id == null || v.is_default === true));
            if (!defaultView || !Array.isArray(defaultView.columns)) return;
            const defaultCols = defaultView.columns
                .slice()
                .sort((a, b) => {
                    const ao = a.display_order == null ? -Infinity : a.display_order;
                    const bo = b.display_order == null ? -Infinity : b.display_order;
                    return ao - bo;
                });
            const catalogByKey = new Map((this.availableColumns || []).map(c => [c.key, c]));
            const newFields = defaultCols
                .filter(c => !!c.visible)
                .map(col => {
                    const meta = catalogByKey.get(col.key) || {};
                    return { ...meta, key: col.key, visible: true };
                });
            this.fields = this.mapCatalogToFields(newFields);
            await this.persistColumnsForActiveView(newFields);
        },
        async onFilterModalSave() {
            this.$bvModal.hide('modal-filter');
            if (this.viewMode !== 'table' || this.isDefaultActiveView) return; // default view / kanban: frontend-only
            await this.persistFiltersForActiveView();
        },
        async persistFiltersForActiveView() {
            const view = this.tableViews[this.activeViewIndex];
            if (!view || view.id == null) return;
            const payload = { filters: this.currentFiltersQuery || '' };
            try {
                const updated = await this.updateTableView({ table: 'recruitment', id: view.id, payload });
                this.$set(this.tableViews, this.activeViewIndex, updated);
                this.activeViewFiltersRaw = updated.filters || '';
            } catch (e) {
                await this.setNotification({
                    msg: typeof e === 'string' ? e : (e && e.detail) || this.$t('teamPage.failedSaveFilters'),
                    type: 'error',
                    color: 'red',
                });
            }
        },
        refreshTabSlider() {
            const tick = (delay) => {
                setTimeout(() => {
                    const tabs = this.$refs.viewsTabs;
                    if (!tabs || !tabs.$el) {
                        if (typeof window !== 'undefined') window.dispatchEvent(new Event('resize'));
                        return;
                    }
                    // eslint-disable-next-line no-unused-vars
                    const _h = tabs.$el.offsetHeight;
                    // eslint-disable-next-line no-unused-vars
                    const _w = tabs.$el.offsetWidth;
                    if (typeof tabs.onResize === 'function') tabs.onResize();
                    if (typeof tabs.callSlider === 'function') tabs.callSlider();
                }, delay);
            };
            this.$nextTick(() => { tick(0); tick(150); tick(400); });
        }
    },
    watch: {
        perPage: {
            async handler() {
                await this.getAllRecruitingData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getAllRecruitingData();
            },
        },
        sortBy: {
            async handler() {
                await this.getAllRecruitingData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getAllRecruitingData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },
        'filterFields.owner'() {
            this.saveKanbanFilters();
        },
        'filterFields.job'() {
            this.saveKanbanFilters();
        },
        activeViewIndex(newVal, oldVal) {
            // Real views live at 0..tableViews.length-1; the last tab is the Add View pseudo-tab.
            if (newVal >= 0 && newVal < this.tableViews.length) {
                this.applyActiveView();
            } else if (this.tableViews.length) {
                // Landed on the Add View pseudo-tab — snap back to a real view.
                const fallback = (oldVal >= 0 && oldVal < this.tableViews.length) ? oldVal : 0;
                this.$nextTick(() => { this.activeViewIndex = fallback; });
            }
        },
    },
    async mounted() {
        this.loadKanbanFilters();
        await this.loadTableViews();
    },
};
</script>
<style>
.note-tooltip-content {
    max-width: 320px;
    white-space: normal;
    word-break: break-word;
    line-height: 1.4;
}
</style>
